module.exports = __webpack_public_path__ + "static/dashboard_testbench-09237a75db577ba7cce10cf7924fad1f.png";